jQuery(document).ready(function($) {
  /*----- utils -----*/
  const isMobile = () => {
    return $(window).width() <= 800;
  };


  /*----- initialize particular operating system -----*/
  async function initializeOperatingSystem() {
    const $topTableDesktopWrap = $(".top-table-desktop .table-wrap");
    const $userAgent = navigator.userAgent || navigator.vendor || window.opera;

    function initializeDynamicContent() {
      if (/android/i.test($userAgent) || !(/iPad|iPhone|iPod/.test($userAgent) && !window.MSStream) ) {
        $(".dynamic-content.android_ver-platform").show();
        $(".dynamic-content.ios_ver-platform").hide();
      } else if (/iPad|iPhone|iPod/.test($userAgent) && !window.MSStream) {
        $(".dynamic-content.ios_ver-platform").show();
        $(".dynamic-content.android_ver-platform").hide();
      }
    }

    function initializeSafari() {
      if (!/Mac OS/i.test($userAgent)) {
        !$topTableDesktopWrap.hasClass("table-wrap--no-safari") &&
        $topTableDesktopWrap.addClass("table-wrap--no-safari");
      } else {
        $topTableDesktopWrap.removeClass("table-wrap--no-safari");
      }
    }

    if ($(".dynamic-content")) {
      initializeDynamicContent();

      $(window).on("resize orientationchange", function() {
        initializeDynamicContent();
      });
    }

    initializeSafari();
  };
  initializeOperatingSystem();


  /*----- advertiser popup -----*/
  const $advertiserElement = $('.advertiser');

  if ($advertiserElement) {
    const $advertiserCloseButton = $('.advertiser-popup .close-btn');
    const $advertiserOpenButton = $('.advertiser__link');

    function closeAdvertiser() {
      $(".advertiser-popup").fadeOut();

      if (window.matchMedia('(max-width: 800px)').matches) {
        $('body').removeClass('noscroll');
      }
    };

    $advertiserOpenButton.on('click', function(event) {
      $(event.currentTarget).closest('.advertiser').find('.advertiser-popup').fadeIn();

      if (window.matchMedia('(max-width: 800px)').matches) {
        $('body').addClass('noscroll');
      }
    });

    $advertiserCloseButton.on('click', function() {
      closeAdvertiser();
    });
  }

  $(window).on('click', function (event) {
    if (!event.target.closest('.advertiser__link') &&
      !event.target.closest('.advertiser-popup__content')) {
      closeAdvertiser();
    }
  })


  /*----- mobile table -----*/
  const $topTableMobile = $(".top-table-mobile");
  const $openPopupButton = $(".top-table-mobile .link--show-more");
  const $closePopupButton = $(".popup_close");
  let $isPopupOpen = false;

  function openPopup(event) {
    $(event.currentTarget).toggleClass("active").closest(".table-row").toggleClass("popup--is-open")
      .find(".popup-overlay").addClass("is-shown")
      .find(".popup-wrapper").addClass("is-shown");

    $isPopupOpen = true;
    window.history.pushState("forward", null, "");
  };

  function closePopup() {
    $(".popup--is-open").removeClass("popup--is-open")
      .find(".popup-overlay").removeClass("is-shown")
      .find(".popup-wrapper").removeClass("is-shown");

    $isPopupOpen = false;
  };

  if ($topTableMobile) {
    $(this).find(".table-row:first").addClass("firstTop");

    $openPopupButton.on("click", function(event) {
      openPopup(event);
    });

    $closePopupButton.on("click", function() {
      closePopup();
    });

    $(".popup-overlay").on("click", function (event) {
      if (!$(".popup").is(event.target) && $(".popup").has(event.target).length === 0 ) {
        closePopup();
      }
    });

    $(window).on("popstate", function() {
      closePopup();
    });
  }


  /*----- desktop table -----*/
  const $topTableDesktop = $(".top-table-desktop");

  if ($topTableDesktop) {
    const $tableRowMain = $(".top-table-desktop tbody tr.row--main");
    const $tableRowExtended = $(".top-table-desktop tbody tr.row--extended");
    const $openRowButton = $(".top-table-desktop .link--show-more");
    const $closeRowButton = $(".row--extended .close-btn");
    const $tooltipLink = $(".link--with-tooltip");
    const $tooltip = $(".top-table-desktop .tooltip");

    $tableRowMain.first().addClass("firstTop");
    $tableRowExtended.first().addClass("firstTop");
    $tableRowExtended.addClass("is-close");

    $openRowButton.on("click", function (event) {
      $(event.currentTarget)
        .toggleClass("active")
        .closest(".row--main").toggleClass("active")
          .nextAll(".row--extended:first").toggleClass("is-close");
    });

    $closeRowButton.on("click", function (event) {
      $(event.currentTarget)
        .closest(".row--extended").addClass("is-close")
        .prev(".row--main.active").removeClass("active")
        .find(".link--show-more").removeClass("active");
    });

    $tooltip.on("mouseenter", function (event) {
      $(event.currentTarget).addClass("active");
    });

    $tooltip.on("mouseleave", function (event) {
      $(event.currentTarget).removeClass("active");
    });

    $tooltipLink.on("mouseenter", function(event) {
      $tooltipText = $('<span class="tooltip__text">Coming Soon</span>');
      $(event.currentTarget).addClass("tooltip active").append($tooltipText);
    })

    $tooltipLink.on("mouseleave", function (event) {
      $this = $(event.currentTarget);
      mouseLeaveTimer = setTimeout(function(){
        $this.removeClass("tooltip active").find(".tooltip__text").remove();
      }, 400);
    });
  }


  /*----- partner popup -----*/
  if (!isMobile()) {
    const $topTablePartnerPopup = $(".landings-template-default .partner-popup");
    const $topTablePartnerPopupButton = $(".landings-template-default .partner-popup .close-button");
    const $partnerPopupDelay = JSON.parse($topTablePartnerPopup.attr("data-delay"));

    let $isModalVisible = false;
    let $isPopupTrigger = true;
    let $partnerPopupCloseTime = '';
    const $pageInitializationTime = new Date();

    function showPartnerPopup() {
      $topTablePartnerPopup.fadeIn();
      $topTablePartnerPopup.addClass("partner-popup--show");

      $isModalVisible = true;
    };

    function closePartnerPopup() {
      if ($topTablePartnerPopup.hasClass("partner-popup--show") &&
        $isModalVisible) {
        $topTablePartnerPopup.fadeOut();
        $topTablePartnerPopup.removeClass("partner-popup--show");

        $isModalVisible = false;
        $partnerPopupCloseTime = new Date();
      }
    };

    function getTime(time) {
      return Math.round(time.getTime() / 1000);
    };

    function checkSameTime(timeFirst, timeSecond, condition) {
      if (getTime(timeSecond) - getTime(timeFirst) > condition) {
        return true;
      }
    };

    function checkPartnerPopupCloseTime(popupCloseTime, currentTime) {
      if (popupCloseTime) {
        return checkSameTime(popupCloseTime, currentTime, 30);
      } else {
        return true;
      }
    };

    function checkPageSessionTime(pageInitializationTime, currentTime) {
      let $delay = Number($partnerPopupDelay);

      return checkSameTime(pageInitializationTime, currentTime, $delay);
    };

    $(document).on("mouseleave", function(event) {
      const $currentTime = new Date();

      if ($isPopupTrigger !== false &&
        checkPageSessionTime($pageInitializationTime, $currentTime) &&
        checkPartnerPopupCloseTime($partnerPopupCloseTime, $currentTime) &&
        !$isModalVisible &&
        event.clientY < 0) {
        showPartnerPopup();
      }
    });

    $topTablePartnerPopupButton.on("click", function() {
      closePartnerPopup();

      $isPopupTrigger = false;
    });

    $(window).on("click", function(event) {
      if (!event.target.closest(".partner-popup__body")) {
        closePartnerPopup();
      }
    });
  }
});

